import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { Home } from './features/home/home';
export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: Home,
      },
      {
        path: 'check-mail',
        loadComponent: () => import('./features/check-mail/check-mail').then((m) => m.CheckMail),
      },
            {
        path: 'consulta-turnos',
        loadComponent: () => import('./features/consultation-appointment/consultation-appointment').then((m) => m.ConsultationAppointment),
      },
      {
        path: 'cancel-appointment',
        loadComponent: () =>
          import('./features/cancel-appointment/cancel-appointment').then(
            (m) => m.CancelAppointment
          ),
      },
      {
        path: 'busqueda',
        loadComponent: () =>
          import('./features/turnos/pages/busqueda-turnos/busqueda-turnos').then(
            (m) => m.BusquedaTurnos
          ),
      },
      {
        path: 'busqueda/:institucion/:especialidad/:cobertura',
        loadComponent: () =>
          import('./features/turnos/pages/busqueda-turnos/busqueda-turnos').then(
            (m) => m.BusquedaTurnos
          ),
      },
      {
        path: 'perfil/:perfil',
        loadComponent: () => import('./features/perfil/perfil').then((m) => m.Perfil),
      },
      {
        path: 'turno/:profesional/:cobertura',
        loadComponent: () => import('./features/calendario/calendario').then((m) => m.Calendario),
      },
      {
        path: 'turno-express/:especialidad/:cobertura',
        loadComponent: () => import('./features/turno-express/turno-express').then((m) => m.Calendario),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '', // fallback a la raíz
  },
];
